export function getOptimisticChatAccountName({
  displayAccountName,
  accountName,
}: {
  displayAccountName?: string;
  accountName?: string;
}): string {
  return displayAccountName ?? accountName ?? 'New Chat';
}
